// extracted by mini-css-extract-plugin
export default {"smoothly_appear":"square-button_smoothly_appear__RYau+","smoothly-appear":"square-button_smoothly-appear__2OlPa","square_button":"square-button_square_button__A4fde"};